function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h16v16H0z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-3.502-3.005a1 1 0 00-1.415 0L7 9.085 5.207 7.294a1 1 0 00-1.414 1.414l2.5 2.5a1 1 0 001.414 0l4.79-4.798a1 1 0 000-1.414z",
  fill: "#6C8EEF"
})));